<div>
  <div class="form-inline">
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon">{{ profileName }}</div>
        <div class="input-group-addon">{{ value }}</div>
        <div class="input-group-btn">
          <button pButton type="button" class="btn btn-default" icon="pi pi-search" (click)="showSearch()"></button>
        </div>
      </div>
    </div>
  </div>

  <p-dialog
    #profileLookupModal
    [(visible)]="showModal"
    modal="true"
    [closable]="true"
    styleClass="atlas-dialog-l"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      <h4 class="modal-title">Profile Selector</h4>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-inline">
            <div class="form-group">
              <div class="input-group">
                <input
                  (keydown.Enter)="executeSearch($event)"
                  autofocus
                  class="form-control"
                  type="text"
                  [(ngModel)]="profileSearchParams.Keyword"
                />

                <span class="input-group-btn">
                  <button
                    pButton
                    type="button"
                    class="btn btn-default"
                    icon="pi pi-search"
                    [label]="'common.search' | translate"
                    (click)="executeSearch($event)"
                  ></button>
                  <wl-busy [show]="isSearching"></wl-busy>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div style="height: 375px">
      <div *ngIf="searchHasResults">
        <div>
          <p-table [showGridlines]="true"
            scrollHeight="100%"
            scrollWidth="100%"
            [value]="profileResults.Result"
            [rows]="10"
            [paginator]="true"
            [pageLinks]="3"
            [rowsPerPageOptions]="[5, 10, 20]"
            [lazy]="true"
            [totalRecords]="profileResults.TotalCount"
            (onLazyLoad)="executeSearch($event)"
          >
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'ReportName'">
                  {{ 'common.personal-information.profile-name' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Email'">
                  {{ 'common.personal-information.email-address' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Member'">
                  {{ 'common.member' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-profile>
              <tr>
                <td>
                  <a (click)="selectProfile(profile.ProfileId)">{{ profile.ReportName }}</a>
                </td>
                <td style="overflow: hidden">{{ profile.Email }}</td>
                <td><input class="pull-right" type="checkbox" disabled [(ngModel)]="profile.Member" /></td>
              </tr>
            </ng-template>
          </p-table>
          <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
        </div>
      </div>
      <div *ngIf="!searchHasResults && searchPerformed">
        <h4>{{ 'common.phrases.no-results-found' | translate }}</h4>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div>
        <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="this.showModal = false">Close</button>
      </div>
    </ng-template>
  </p-dialog>
</div>
